import axios from 'axios';
import router from '../router';
import { Notification } from 'element-ui';

// 根域名地址
axios.defaults.withCredentials = true;
const serverUrl = {
    'TEST_SERVER': '/api',
    'PRODUCTION_SERVER': ''
};

export const axiosInstance = axios.create({
    baseURL: serverUrl.PRODUCTION_SERVER,
    timeout: 30000
});

var httpFlag = 0;
var notification = 0;

// Http拦截器
axiosInstance.interceptors.request.use(request => {
    request.headers['x-requested-with'] = 'XMLHttpRequest';
    const token = localStorage.getItem('authToken');
    if(token)
        request.headers['X-Token'] = token;
    if(httpFlag === 0){
        httpFlag++;
    }
    return request;
}, err => Promise.reject(err));

axiosInstance.interceptors.response.use(response => {
    httpFlag--;
    notification++;
    if (response.data.status === 403 || response.data.status === 403) {
        router.replace('/Login');
        if(notification === 1){
            Notification({
                type: 'warning',
                title: response.data.message
            });
        } else if(notification === 2){
            notification = 0;
        }
    }

    return response;
});
// http方法封装
export class HttpClient {
    static post(url, param, opts) {
        return axiosInstance.post(url, param, opts);
    }
    static get(url, opts) {
        return axiosInstance.get(url, opts);
    }
}

// export serverUrl;